import { useAuth } from "../context/AuthContext";

export function PreviewSpacer() {
  const { config } = useAuth();
  return config?.is_preview ? <div className="h-6 shrink-0" /> : null;
}
